import React, { FC } from 'react';
import MuiPagination, { PaginationProps as MuiPaginationProps } from '@material-ui/lab/Pagination';
import { Uds } from '../../types';

export type PaginationProps = Uds<MuiPaginationProps & {}>;

export const Pagination: FC<React.PropsWithChildren<PaginationProps>> = ({ dataTest, ...props }) => (
  <MuiPagination data-test={dataTest} {...props} />
);
